export default __webpack_public_path__ + "locales/bg/Common.json?hash=633639519822e8656f2351bbc586a293";